import { Context, CustomQuery } from '@vue-storefront/core';
import { ApiResult } from '../../types';
// 支付
export default async function orderPay(context: Context, params: CustomQuery): Promise<ApiResult> {
  const url = new URL('/mall/order/payment', context.config.api.url);
  const { data: res } = await context.client.post(url.href, params, { timeout: 30000 });
  return res;
}
